import { useParams } from "react-router-dom";
import { useGetDraftRestockDetails } from "../../../../../../hooks/api/queries";
import BulkRestock from "../../../BulkRestock";
import secondaryComponents from "../../../../../../components/secondaryComponents";

const ContinueBulkRestock = () => {
  const { restock_id } = useParams();
  const { data: restockDetails, isLoading } = useGetDraftRestockDetails({
    id: restock_id,
  });

  return (
    <secondaryComponents.LoaderHelper isLoading={isLoading} classNames={"mt-5"}>
      <BulkRestock restockDetails={restockDetails} />
    </secondaryComponents.LoaderHelper>
  );
};
export default ContinueBulkRestock;
